import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import ThirdPartyAgreementsPopupBlockData from "../../../Models/Content/ThirdPartyAgreementsPopupBlockData";
import ThirdPartyAgreementsPopup from "./ThirdPartyAgreementsPopup";

export default class ThirdPartyAgreements extends EpiComponent<ThirdPartyAgreementsPopupBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return (
      <ThirdPartyAgreementsPopup context={this.getContext()} iContent={this.props.data} />
    );
  }
}
